import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_009.jpg';

page.games = [
  {
    id: 'page009_game0',
    icon: 'ikonaCwiczenie',
    color: '#FF808080',
    tooltip: 's. 9',
    pos: {
      x: RIGHT,
      y: 40,
    },
    item: {
      id: 'page009_game0',
    },
  },
];

export default page;
